import React from 'react';

import { Label, StyledErrorMessage } from './ErrorMessage.style';

export interface ErrorMessageProps {
    message?: string;
}

export function ErrorMessage({ message = 'An unknown error has occured.' }: ErrorMessageProps) {
    return (
        <StyledErrorMessage>
            <Label>{message}</Label>
        </StyledErrorMessage>
    );
}
